import React from 'react';
import { Link, useParams } from 'react-router-dom';

function PortfolioDetail() {
  const { portfolioId } = useParams();
  
  return (
    <div className="authenticated-page">
      <div className="authenticated-page-content">
        <h1 className="authenticated-page-title">Portfolio Detail</h1>
        <p className="authenticated-page-body">
          This page will display detailed information for portfolio ID: {portfolioId}, including
          holdings, performance, alerts, and management tools.
        </p>
        <nav className="authenticated-page-nav">
          <Link to="/portfolios">← Back to Portfolios</Link>
          {' | '}
          <Link to="/dashboard">Dashboard</Link>
        </nav>
      </div>
    </div>
  );
}

export default PortfolioDetail;
